import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Registration} from '../models/user';
import {Observable, throwError} from 'rxjs';
import {environment} from '../../../environments/environment';
import {AuthResources} from './auth-resources';
import {catchError, map} from 'rxjs/operators';
import {AuthError, AuthErrorCodes} from '../models/auth-error';

@Injectable()
export class RegistrationService {

    constructor(private http: HttpClient) {
    }

    registrationErrorSelector(err: any) {
        const errorCode = AuthErrorCodes.InvalidCredentials;
        let message = '';
        if (err.constructor.name === HttpErrorResponse.name) {
            const error = <HttpErrorResponse>err;

            if (error.error && error.error.message) {
                message = error.error.message;
            }
        }
        return throwError(new AuthError(
            errorCode,
            message,
            err
        ));
    }

    /**
     * @return Observable of type boolean returns success
     */
    register(registration: Registration): Observable<void> {
        const resourceUrl = environment.rest_backend + AuthResources.registerResource;

        return this.http.post(resourceUrl, registration, {
            headers: {
                'h-captcha-response': registration.captcha
            },
            withCredentials: false
        }).pipe(
            map(() => void 0),
            catchError(this.registrationErrorSelector)
        );
    }

}
